module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-xy-center"
  }, [_c('h1', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "color": "grey"
    }
  }, [_vm._v("Hilfe")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf4df85","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Hilfe.vue
// module id = 1980
// module chunks = 1